import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { ChevronDownIcon } from '@heroicons/react/16/solid'
import { useEffect, useRef, useState } from 'react';
import { changeProfilePhoto, getProfile, updateMyProfile } from '../services/userService';
import { User } from '../interface/user';
import { Camera } from 'lucide-react';

export default function ProfileContent() {
  const imageUrl = "https://www.dpnaik.com/img/profile.jpg";
  const [isEditing, setIsEditing] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [photo, setPhoto] = useState<File | null>(null);
  const didRun = useRef(false);
  const [user, setUser] = useState<User>({
    _id: '',
    customer_id: '',
    fname: '',
    mname: '',
    lname: '',
    email: '',
    contact: '',
    dob: '',
    gender: '',
    address: '',
    aadhaar: '',
    pan: '',
    hl_kyc: '',
    hl_declaration: '',
    employment_type: '',
    employer_name: '',
    credit_score: '',
    annual_income: '',
    communication_preference: [],
    joined_on: '',
    last_login: '',
    last_modified: ''
  });

  const communicationOptions: string[] = ["e-mail", "SMS", "Call", "Whatsapp"];
  const [selectedImage, setSelectedImage] = useState<string | null>(localStorage.getItem("user_photo") != 'photo_url'?localStorage.getItem("user_photo"): null);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // ✅ Check file size (200 KB = 204800 bytes)
    if (file.size > 204800) {
      alert("File size must be less than 200KB.");
      return;
    }

    setPhoto(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result as string);
      setIsEditing2(true)
    };
    reader.readAsDataURL(file);
  };

  const onSave = async () => {
    if (!photo) return;
    try {
      const formData = new FormData();
      formData.append("file", photo);

      // 🔥 Replace with your API call
      var res = await changeProfilePhoto(formData);
      localStorage.setItem("user_photo",res.message.photo_url)
      alert("Profile photo saved");
      window.location.reload();
    } catch (err) {
      console.error("Error saving profile photo:", err);
    }
  };

  const handleRemove = () => {
    setSelectedImage(null);
    setIsEditing2(false)

  };
  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setUser({
  //     ...user,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "dob") {
      if (value) {
        const [year, month, day] = value.split("-");
        const formattedDob = `${day}-${month}-${year}`;
        setUser((prev) => ({ ...prev, [name]: formattedDob }));
      } else {
        setUser((prev) => ({ ...prev, [name]: "" }));
      }
    } else {
      setUser((prev) => ({ ...prev, [name]: value }));
    }
  }

  const handleChange3 = (e: any) => {
    const { name, value } = e.target;
    setUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

   useEffect(() => {
     if (!didRun.current) {
       didRun.current = true;
       getMyProfile();
     }
 
     window.history.pushState(null, "", window.location.href);
     const handlePopState = () => {
       window.history.pushState(null, "", window.location.href);
     };
 
     window.addEventListener("popstate", handlePopState);
     return () => {
       window.removeEventListener("popstate", handlePopState);
     };
   }, []);
 
   const getMyProfile = async () => {
     try {
       const result = await getProfile();
       setUser(result.message);
       console.log(result.message)
     } catch (error) {
       console.error("Error in fetching data:", error);
     }
   };

   const formatDateForInput = (dateStr: string) => {
    if(dateStr){
      const normalized = dateStr?.replace(/\//g, "-");
      const [day, month, year] = normalized?.split("-");
      return `${year}-${month}-${day}`;
    }else{}

    }

  const updateProfile = async () => {
    console.log('Form submitted:', user);
    const result = await updateMyProfile(user);
    localStorage.setItem("user", JSON.stringify(result.user));

    window.location.reload();
  }
  return (
    <div>
      <div className="space-y-12">
        <div className="border-b border-gray-900/10 pb-3">
          <div className="mt-1 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
            <div className="col-span-full">
              <p className="mt-1 max-w-2xl text-sm/6 text-gray-500">
                <span className="block sm:inline whitespace-nowrap"><b>Customer ID:</b> {user.customer_id}&nbsp;&nbsp;</span>
                <span className="hidden sm:inline whitespace-nowrap mx-2">|</span>
                <span className="block sm:inline whitespace-nowrap"><b>Email:</b> {user.email}&nbsp;&nbsp;</span>
                <span className="hidden sm:inline whitespace-nowrap mx-2">|</span>
                <span className="block sm:inline whitespace-nowrap"><b>Mobile:</b> +{user.contact}</span>
              </p>
               <p className="mt-1 max-w-2xl text-sm/6 text-gray-500">
                <span className="block sm:inline whitespace-nowrap"><b>HL KYC:</b> {user.hl_kyc}&nbsp;&nbsp;</span>
                <span className="hidden sm:inline whitespace-nowrap mx-2">|</span>
                <span className="block sm:inline whitespace-nowrap"><b>HL Declaration:</b> {user.hl_declaration}&nbsp;&nbsp;</span>
                <span className="hidden sm:inline whitespace-nowrap mx-2">|</span>
                <span className="block sm:inline whitespace-nowrap"><b>Credit Score:</b> {user.credit_score}</span>
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center space-y-4">
          {/* Profile image */}
          <div className="relative w-32 h-32">
            <img
              src={
                selectedImage || "https://static.vecteezy.com/system/resources/previews/005/544/718/non_2x/profile-icon-design-free-vector.jpg"
              }
              // alt="Profile"
              className="w-32 h-32 rounded-full object-cover border shadow"
            />

            {/* Camera Icon Overlay */}
            <label
              htmlFor="photo-upload"
              className="absolute bottom-0 right-0 bg-blue-600 p-2 rounded-full cursor-pointer shadow-md hover:bg-blue-700 transition"
            >
              <Camera className="text-white w-5 h-5" />
            </label>

            <input
              id="photo-upload"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleImageChange}
            />
          </div>

          {/* Actions */}
          {isEditing2 && (
            <div className="flex gap-3">
              <button
                onClick={handleRemove}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
              >
                Remove
              </button>
              <button
                onClick={onSave}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                Save
              </button>
            </div>
          )}
        </div>

        <div className="border-b border-gray-900/10 pb-12">
          <h2 className="text-base/7 font-semibold text-gray-900">Personal Information</h2>
                  {/* Edit button (visible only when not editing) */}
        {!isEditing && (
          <div className="mt-6 flex items-center justify-end gap-x-6">
            <button
              onClick={() => setIsEditing(true)}
              className="rounded-md border border-indigo-600 px-3 py-2 text-sm font-semibold text-indigo-600 hover:bg-indigo-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Edit
            </button>
          </div>
        )}

        {/* Save + Cancel buttons (visible only when editing) */}
        {isEditing && (
          <div className="mt-6 flex items-center justify-end gap-x-6">
            <button
              type="button"
              onClick={() => setIsEditing(false)}
              className="text-sm/6 font-semibold text-gray-900"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                updateProfile();
                setIsEditing(false); // hide save/cancel and go back to Edit
              }}
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Save
            </button>
          </div>
        )}
            <div className="mt-1 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
              <div className="sm:col-span-2 sm:col-start-1">
                <label htmlFor="fname" className="block text-sm/6 font-medium text-gray-900">
                  First Name
                </label>
                <div className="mt-2">
                  <input
                    readOnly = {!isEditing}
                    disabled = {!isEditing}
                    id="fname"
                    name="fname"
                    type="text"
                    autoComplete="fname"
                    value={user.fname}
                    onChange={handleChange}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>

              <div className="sm:col-span-2">
                <label htmlFor="region" className="block text-sm/6 font-medium text-gray-900">
                  Middle Name
                </label>
                <div className="mt-2">
                  <input
                    readOnly = {!isEditing}
                    disabled = {!isEditing}
                    id="mname"
                    name="mname"
                    type="text"
                    autoComplete="mname"
                    value={user.mname}
                    onChange={handleChange}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>

              <div className="sm:col-span-2">
                <label htmlFor="postal-code" className="block text-sm/6 font-medium text-gray-900">
                  Last Name
                </label>
                <div className="mt-2">
                  <input
                    readOnly = {!isEditing}
                    disabled = {!isEditing}
                    id="lname"
                    name="lname"
                    type="text"
                    autoComplete="lname"
                    value={user.lname}
                    onChange={handleChange}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label htmlFor="gender" className="block text-sm/6 font-medium text-gray-900">
                  Gender
                </label>
                <div className="mt-2 grid grid-cols-1">
                  <select
                    // readOnly = {!isEditing}
                    disabled = {!isEditing}
                    id="gender"
                    name="gender"
                    value={user.gender} // ✅ controlled value
                    onChange={handleChange} // ✅ handle changes
                    autoComplete="gender"
                    className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Transgender">Transgender</option>
                  </select>
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label htmlFor="dob" className="block text-sm/6 font-medium text-gray-900">
                  Date of Birth
                </label>
                <div className="mt-2">
                  <input
                    readOnly = {!isEditing}
                    disabled = {!isEditing}
                    id="dob"
                    name="dob"
                    type="date"
                    autoComplete="dob"
                    value={formatDateForInput(user.dob)}
                    onChange={handleChange2}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>

              <div className="col-span-full">
                <label htmlFor="about" className="block text-sm/6 font-medium text-gray-900">
                  Address
                </label>
                <div className="mt-2">
                  <textarea
                    readOnly = {!isEditing}
                    disabled = {!isEditing}
                    id="about"
                    name="about"
                    rows={3}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                    defaultValue={user.address}
                    onChange={(e) =>
                      setUser({ ...user, address: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label htmlFor="first-name" className="block text-sm/6 font-medium text-gray-900">
                  Aadhaar
                </label>
                <div className="mt-2">
                  <input
                    readOnly = {!isEditing}
                    disabled = {!isEditing}
                    id="aadhaar"
                    name="aadhaar"
                    type="text"
                    autoComplete="given-name"
                    value={user.aadhaar}
                    onChange={handleChange}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label htmlFor="last-name" className="block text-sm/6 font-medium text-gray-900">
                  PAN
                </label>
                <div className="mt-2">
                  <input
                    readOnly = {!isEditing}
                    disabled = {!isEditing}
                    id="pan"
                    name="pan"
                    type="text"
                    autoComplete="pan"
                    value={user.pan}
                    onChange={handleChange}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label htmlFor="first-name" className="block text-sm/6 font-medium text-gray-900">
                  Employment Type
                </label>
                <div className="mt-2 grid grid-cols-1">
                  <select
                    disabled = {!isEditing}
                    id="employment_type"
                    name="employment_type"
                    value={user.employment_type} // ✅ controlled value
                    onChange={handleChange} // ✅ handle changes
                    autoComplete="employment_type"
                    className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  >
                    <option value="Salaried">Salaried</option>
                    <option value="Self-Employed">Self-Employed</option>
                    <option value="Unemployed">Unemployed</option>
                    <option value="Student">Student</option>
                    <option value="Retired">Retired</option>
                    <option value="Other">Other</option>
                  </select>
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label htmlFor="last-name" className="block text-sm/6 font-medium text-gray-900">
                  Employer Name
                </label>
                <div className="mt-2">
                  <input
                    readOnly = {!isEditing}
                    disabled = {!isEditing}
                    id="employer_name"
                    name="employer_name"
                    type="text"
                    autoComplete="employer_name"
                    value={user.employer_name}
                    onChange={handleChange}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>


              <div className="sm:col-span-3">
                <label htmlFor="last-name" className="block text-sm/6 font-medium text-gray-900">
                  Annual Income
                </label>
                <div className="mt-2">
                  <input
                    readOnly = {!isEditing}
                    disabled = {!isEditing}
                    id="annual_income"
                    name="annual_income"
                    type="text"
                    autoComplete="annual_income"
                    value={user.annual_income}
                    onChange={handleChange}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>
              
              <div className="sm:col-span-3">
                <label className="block text-sm/6 font-medium text-gray-900">
                  Communication Preference
                </label>
                <div className="mt-2 flex gap-4">
                  {communicationOptions.map((option) => (
                    <label key={option} className="flex items-center gap-2 cursor-pointer">
                      <input
                        readOnly = {!isEditing}
                        disabled = {!isEditing}
                        type="checkbox"
                        name="communication_preference"
                        value={option}
                        checked={user.communication_preference.includes(option)}
                        onChange={(e) => {
                          const value = e.target.value;
                          let updated: string[];
                          if (e.target.checked) {
                            updated = [...user.communication_preference, value];
                          } else {
                            updated = user.communication_preference.filter((v) => v !== value);
                          }
                          setUser((prev) => ({
                            ...prev,
                            communication_preference: updated,
                          }));
                        }}
                        className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
                      />
                      <span className="text-gray-700">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}
